import { createSelector } from 'reselect';
import { AdminState } from './admin.slice';

const selectAdminState = (state: { admin: AdminState }) => state.admin || {};

export const adminFranchiseSelector = createSelector(selectAdminState, admin => admin.franchise);

export const adminFranchiseEntitySelector = createSelector(selectAdminState, admin => admin.franchise.entity);

export const adminFranchiseLoadingSelector = createSelector(selectAdminState, admin => admin.franchise.isLoading);

export const adminFranchisePartnerSelector = createSelector(selectAdminState, admin => admin.franchise.partner);

export const adminFranchisePartnerSavingSelector = createSelector(
  selectAdminState,
  admin => admin.franchise.isPartnerSaving,
);

export const adminDeactivationDialogSelector = createSelector(
  selectAdminState,
  admin => admin.franchise.deactivationDialog,
);

export const adminFranchiseErrorSelector = createSelector(selectAdminState, admin => admin.franchise.hasError);

export const adminSenderIdModalSelector = createSelector(selectAdminState, admin => admin.franchise.senderIdModal);

export const adminSenderIdValiditySelector = createSelector(
  selectAdminState,
  admin => admin.franchise.senderIdValidity,
);

export const adminStoresTotalSelector = createSelector(selectAdminState, admin => admin.stores.entities.length);

export const adminStoresSelector = createSelector(selectAdminState, admin => admin.stores.entities);

export const adminStoresLoadingSelector = createSelector(selectAdminState, admin => admin.stores.areLoading);

export const adminStoresErrorSelector = createSelector(selectAdminState, admin => admin.stores.hasError);

export const adminLoyaltyModelSelector = createSelector(selectAdminState, admin => admin.loyaltyModel);

export const adminConversionRateSelector = createSelector(selectAdminState, admin => admin.conversionRate);

export const adminOwnersSelector = createSelector(selectAdminState, admin => admin.owners);
